import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { Tag } from './typings';

const baseUrl = 'contentful/tags';

export const getTags = baseService<undefined, Tag[]>(() =>
  HttpClient.get(baseUrl),
);
